import { TabContent } from 'reactstrap';
import PropTypes from 'prop-types';
import DatosAlumnos from './DatosAlumnos';
import Loader from '../../layouts/loader/Loader';
import DatosTutores from './DatosTutores';
import DatosFacturas from './DatosFacturas';
import DatosRecibos from './DatosRecibos';

const PestañasDatos = (props) => {
  return (
    <>
      {props.dataApi === '' ? (
        <Loader />
      ) : props.dataApi.datos === null ? (
        <p className="mt-2 text-danger">
          <strong>Este alumno no dispone de datos.</strong>
        </p>
      ) : (
        <TabContent className="p-4" activeTab={props.activeTab}>
          <DatosAlumnos datosAlumno={props.dataApi} />
          <DatosTutores datosTutor={props.dataApi} />
          <DatosFacturas datosFacturas={props.dataFacturas} />
          <DatosRecibos datosRecibos={props.dataRecibos} onRecargar={props.onRecargarRecibos} />
        </TabContent>
      )}
    </>
  );
};

PestañasDatos.propTypes = {
  activeTab: PropTypes.string,
  dataApi: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      datos: PropTypes.shape({}),
    }),
  ]),
  dataFacturas: PropTypes.arrayOf(PropTypes.shape({})),
  dataRecibos: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.shape({}))]),
  onRecargarRecibos: PropTypes.func,
};
export default PestañasDatos;
